<div id="create-association">
    <div class="title-wrapper">
        <h2>Create association</h2>
        <p>Pair a user with a counselor. Both accounts must already exist.</p>
        <a tabindex="0" (click)="close()" (keypress)="close()" class="close-modal"
            aria-label="Close create association form">
            <img src="./assets/img/icons-svg/close-icon.svg" />
        </a>
    </div>

    <form novalidate [formGroup]="associationForm" (ngSubmit)="save()">
        <div class="form-wrapper">
            <div class="app-c-form-group">
                <label for="associationUserEmail">User email</label>
                <input id="associationUserEmail" class="app-c-form-control" type="email"
                    formControlName="userEmail" placeholder="user@example.com" />
                <div class="error-message" *ngIf="f.userEmail.touched && f.userEmail.errors">
                    Please enter a valid user email address.
                </div>
            </div>

            <div class="app-c-form-group">
                <label for="associationCounselorEmail">Counselor email</label>
                <input id="associationCounselorEmail" class="app-c-form-control" type="email"
                    formControlName="counselorEmail" placeholder="counselor@example.com" />
                <div class="error-message" *ngIf="f.counselorEmail.touched && f.counselorEmail.errors">
                    Please enter a valid counselor email address.
                </div>
            </div>

            <div class="app-c-form-group">
                <label for="associationOrg">Organization</label>
                <!-- [ngValue] so the numeric org id stays a number, not "2418". -->
                <select id="associationOrg" class="app-c-form-control" formControlName="orgId">
                    <option [ngValue]="null" disabled>Select an organization</option>
                    <option *ngFor="let organization of organizations" [ngValue]="organization.id">
                        {{ organization.name }}
                    </option>
                </select>
                <div class="error-message" *ngIf="f.orgId.touched && f.orgId.errors">
                    Please select an organization.
                </div>
            </div>

            <div class="error-message server-error" *ngIf="errorMessage">
                {{ errorMessage }}
            </div>
        </div>

        <div class="fixed-footer">
            <button type="button" class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                (click)="close()">Cancel</button>
            <button type="submit" class="app-c-btn app-c-btn--primary app-c-btn--curve"
                [disabled]="isSaving">
                {{ isSaving ? 'Creating…' : 'Create association' }}
            </button>
        </div>
    </form>
</div>
